const {h, render, Component} = require('preact')
const {route} = require('preact-router');

const TabsContainer = require('../common/tabs')
const OrdersContainer = require('./orders')
const FaqsContainer = require('../faq/faqs')
const OrderSummaryContainer = require('../order/summary')
const GrouponsLandingView = require('../../views/main/groupons_landing')
const LoggedOutLandingPage = require('./logged_out_landing')
const Web2018Helper = require('../../../helper')
const Banner = require ('../../views/common/banner.js')
const Helper = require('../../../helper')
const LoggedInOtherIssues = require('./logged_in_other_issues');


class LandingPage extends Component {
  constructor(props) {
    super(props);
    this.getDefaultLandingPage = this.getDefaultLandingPage.bind(this);
    this.configFromDom = Groupon.Utils.getConfigFromDom();
  }

  componentDidMount() {
    let inbentaSessionToken = sessionStorage.getItem('inbentaSessionKey')
    if (inbentaSessionToken === null || inbentaSessionToken === undefined) {
      Helper.createSession();
    }
  }

  isLoggedIn(){
    if (this.configFromDom && this.configFromDom.user){
      return true;
    }
    return false;
  }

  showTabs() {
    let landingPageTabs = <div id='emptyTab'></div>;
    if (this.configFromDom && this.configFromDom.isRegionNAandBrandGroupon) {
      landingPageTabs = <TabsContainer page="my-groupons"/>
    }
    return landingPageTabs;
  }

  hideHeaderBannerIfPresent() {
    var headerBanner = document.getElementById("header-banner")
    if (headerBanner)
      headerBanner.setAttribute("style", "display:none")
  }

  getDefaultLandingPage() {
    this.hideHeaderBannerIfPresent();
    return (
      <div className="twelve columns">
        <div className="page_header">
          <Banner />
          <h2 className="landing-page-header">{I18n.t('js.modules.web_2018.customer_support')}</h2>
        </div>
        <div className="choose-your-order">
          <h3>{I18n.t('js.modules.web_2018.need_help_with_a_groupon')}</h3>
          <span className="need_help_with_a_groupon">{I18n.t('js.modules.web_2018.choose_your_order_to_proceed')}</span>
        </div>
        {this.showTabs()}
        <OrdersContainer />
        <FaqsContainer />
        { this.configFromDom.fbOrderContactsEnabled  && <LoggedInOtherIssues /> }
      </div>
    );
  }

  routeToContactChannels(){
    let selectedInbentaResult = _.pick(this.props, 'dropdownCategory', 'dropdownSubcategory', 'title', 'primaryCategoryId', 'contentId')
    if(selectedInbentaResult.title)
      selectedInbentaResult.title = decodeURIComponent(selectedInbentaResult.title)
    let qs = Web2018Helper.getQueryStringForFAQToContactChannels(selectedInbentaResult)
    route(`/customer_support/web/contact_channels?${ qs }`);
  }

  render() {
    let landingPage;
    if (this.isLoggedIn()){
      if (this.props.id){
        return (
          <OrderSummaryContainer
            order_id = {this.props.id}
            pageType = "contextual"
          />
        );
      }
      else if (this.props.showContactChannels){
        this.routeToContactChannels();
      }
      landingPage = this.getDefaultLandingPage();
    }
    else{
      landingPage = <LoggedOutLandingPage />;
    }

    return (
      <GrouponsLandingView landingPage={landingPage}/>
    )
  }
}

module.exports = LandingPage
